import EnforcementAppealsSearchState from "@publicPortal/pages/search/EnforcementAppeal/EnforcementAppealsSearchState";
import { EnforcementNoticeSearchState } from "@publicPortal/pages/search/EnforcementNotice/EnforcementNoticeSearchState";
import { PlanningAppealsSearchState } from "@publicPortal/pages/search/PlanningAppeal/PlanningAppealsSearchState";
import { PlanningApplicationSearchState } from "@publicPortal/pages/search/PlanningApplication/PlanningApplicationSearchState";
import { EnforcementAppealsFilter } from "@shared/publicportal/contracts/EnforcementAppealsFilter";
import { EnforcementNoticeFilter } from "@shared/publicportal/contracts/EnforcementNoticeFilter";
import { PlanningAppealsFilter } from "@shared/publicportal/contracts/PlanningAppealsFilter";
import { PlanningApplicationsFilter } from "@shared/publicportal/contracts/PlanningApplicationsFilter";
import { BuildingRegulationsFilter } from "@shared/publicportal/contracts/BuildingRegulationsFilter";
import BuildingRegulationsSearchState from "@publicPortal/pages/search/BuildingRegulations/BuildingRegulationsSearchState";
import { PropertySearchFilter } from "@shared/publicportal/contracts/PropertySearchFilter";

const PublicPortalState = {
    planningAppealInitialSearchState: () => {
        const initialFilterState: PlanningAppealsFilter = {
            appealKeyword: "",
            appealRef: "",
            applicationRef: "",
            planningInspectorateRef: "",
            appealType: "",
            ward: "",
            parish: "",
            decisionType: "",
            appealAddress: "",
            appealCreatedDateFrom: null,
            appealCreatedDateTo: null,
            appealDecisionDateFrom: null,
            appealDecisionDateTo: null,
            appealLodgedDateFrom: null,
            appealLodgedDateTo: null,
            searchType: "Simple",
        };
        const initialSearchState: PlanningAppealsSearchState = {
            searchType: "Simple",
            appealTypes: [],
            appealDecisionTypes: [],
            wards: [],
            parishes: [],
            filter: initialFilterState,
        };

        return { initialSearchState, initialFilterState };
    },

    planningApplicationInitialSearchState: () => {
        const initialFilterState = {
            appRef: "",
            applicant: "",
            appType: "",
            ward: "",
            parish: "",
            agent: "",
            decision: "",
            status: "",
            address: "",
            registeredDateFrom: null,
            registeredDateTo: null,
            committeeDateFrom: null,
            committeeDateTo: null,
            decisionDateFrom: null,
            decisionDateTo: null,
            receivedDateFrom: null,
            receivedDateTo: null,
            validatedDateFrom: null,
            validatedDateTo: null,
            searchType: "Simple",
        } as PlanningApplicationsFilter;

        const initialSearchState: PlanningApplicationSearchState = {
            searchType: "Simple",
            appTypes: [],
            decisions: [],
            wards: [],
            parishes: [],
            filter: initialFilterState,
        };

        return { initialSearchState, initialFilterState };
    },
    enforcementNoticeInitialSearchState: () => {
        const initialFilterState = {
            noticeRef: "",
            complaintRef: "",
            noticeStatus: "",
            noticeType: "",
            noticeWard: "",
            noticeParish: "",
            complianceDeadlineDateFrom: null,
            complianceDeadlineDateTo: null,
            noticeCreatedDateFrom: null,
            noticeCreatedDateTo: null,
            noticeAuthorisedDateFrom: null,
            noticeAuthorisedDateTo: null,
            noticeServedDateFrom: null,
            noticeServedDateTo: null,
            searchType: "Simple",
        } as EnforcementNoticeFilter;

        const initialSearchState: EnforcementNoticeSearchState = {
            searchType: "Simple",
            noticeTypes: [],
            wards: [],
            parishes: [],
            filter: initialFilterState,
        };

        return { initialSearchState, initialFilterState };
    },
    enforcementAppealInitialSearchState: () => {
        const initialFilterState: EnforcementAppealsFilter = {
            keyword: "",
            appealRef: "",
            noticeRef: "",
            inspectorateRef: "",
            appealType: "",
            ward: "",
            parish: "",
            appealLevel: "",
            decisionType: "",
            decisionDateFrom: null,
            decisionDateTo: null,
            claimExpirationDateFrom: null,
            claimExpirationDateTo: null,
            dateStartedFrom: null,
            dateStartedTo: null,
            dateNotifiedFrom: null,
            dateNotifiedTo: null,
            searchType: "Simple",
        };

        const initialSearchState: EnforcementAppealsSearchState = {
            searchType: "Simple",
            decisionTypes: [],
            wards: [],
            parishes: [],
            filter: initialFilterState,
        };

        return { initialSearchState, initialFilterState };
    },
    buildingRegulationsSearchState: () => {
        const initialFilterState: BuildingRegulationsFilter = {
            appRef: "",
            appType: "",
            partnershipType: "",
            applicant: "",
            ward: "",
            parish: "",
            agent: "",
            status: "",
            address: "",
            dateStartedFrom: null,
            dateStartedTo: null,
            completedDateFrom: null,
            completedDateTo: null,
            validationDateFrom: null,
            validationDateTo: null,
            decisionDateFrom: null,
            decisionDateTo: null,
            receivedDateFrom: null,
            receivedDateTo: null,
            searchType: "Simple",
        };

        const initialSearchState: BuildingRegulationsSearchState = {
            searchType: "Simple",
            appTypes: [],
            partnershipTypes: [],
            wards: [],
            parishes: [],
            filter: initialFilterState,
        };

        return { initialSearchState, initialFilterState };
    },
    propertySearch: () => {
        const initialFilterState: PropertySearchFilter = {
            address: "",
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",
            postTown: "",
            postCode: "",
            uprn: "",
            easting: "",
            northing: "",
        };
        const initialSearchState: { filter: PropertySearchFilter } = {
            filter: initialFilterState,
        };
        return { initialSearchState, initialFilterState };
    },
};

export default PublicPortalState;
